export interface StoreOption {
  value: string;
  label: string;
}

export function sortStoresByAvailability(
  options: StoreOption[],
  availableSet: Set<number> | undefined,
): StoreOption[] {
  if (availableSet === undefined) return options;

  const isAvailable = (option: StoreOption): boolean =>
    availableSet.has(Number(option.value));
  const available: StoreOption[] = options.filter(isAvailable);
  const unavailable: StoreOption[] = options.filter(
    (option) => !isAvailable(option),
  );

  return [...available, ...unavailable];
}